export const ContractPersonStatus = {
  step2: [2, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43],
  step2_3Property: [
    2, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43,
  ],
  step3: [18, 20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43],
  step3Car: [16, 20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43],
  step4: [20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43],
  step4Cargo: [18, 20, 25, 30, 31, 32, 33, 38, 39, 40, 41, 42, 43],
}

export const ContractPersonRetailStatus = {
  step2: [2, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 30, 31, 32, 33, 39, 40, 41, 42, 43],
  step3: [20, 30, 31, 32, 33, 39, 40, 41, 42, 43],
}
